/**
 * 分钟转ms
 * @param min 分钟
 * @returns
 */
export var getMilSeconds = function getMilSeconds(min) {
  if (!min) {
    return 0;
  }

  return min * 60 * 1000;
};
/**
 * 在localStorage存储数据和有效时间
 * @param key 存储数据的key
 * @returns
 * |参数|值类型|说明|
 * |:---|:---|:---|
 * |data|string|存储的数据|
 * |isExpired|boolean|true(过期)|
 *
 */

export var getStorageData = function getStorageData(key) {
  if (!key) {
    return {
      data: '',
      isExpired: true
    };
  } // 当前时间戳


  var timestamp = new Date().getTime(); // 上次时间戳

  var prevTimestamp = localStorage.getItem("".concat(key, "_TIME")) || 0;
  var prevKconfData = localStorage.getItem(key);
  return {
    data: prevKconfData || '',
    isExpired: prevTimestamp ? timestamp > +prevTimestamp : true
  };
};
/**
 *
 * @param key 数据key
 * @param data 数据
 * @param ExpireTime 有效期（min）
 * @returns
 */

export var setStorageData = function setStorageData(key, data, ExpireTime) {
  if (!key) {
    return false;
  } // 当前时间戳


  var timestamp = new Date().getTime();
  localStorage.setItem(key, typeof data === 'string' ? data : JSON.stringify(data));
  localStorage.setItem("".concat(key, "_TIME"), "".concat(timestamp + getMilSeconds(ExpireTime)));
  return true;
};